<template>
  <section class="bar">
    <div class="top-icons">
      <img src="../../assets/icone-busca.svg" alt="" />
      <img src="../../assets/icone-folder2.svg" alt="" />
    </div>
    <div class="bottom-icons">
      <img src="../../assets/icone-ajuste.svg" alt="" />
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style>
@import url("./style.scss");
</style>
